import React from "react";
import {convertPriceUnitAmountToReadable, daysBetween, getDateStr, getFormattedMessage} from "../../../helpers/helpers";
import {ROLES} from "../../../constants";
import GenericItem from "../../common/items/GenericItem";

const AcCostItem = ({ price, payNow, role, expirationDate, doNotRenew = false }) => {
    const daysUntilExpired = daysBetween(new Date(), new Date(expirationDate));

    let amount = convertPriceUnitAmountToReadable(price.amount);
    if (amount && role === ROLES.END_USER && daysUntilExpired < -60) {
        amount *= 1.15;
        amount = amount.toFixed(2);
    }

    let costText = getFormattedMessage(i18n.payments.ac.basicPlanCostNote, amount);

    let infoText;
    if (daysUntilExpired > 0 && !payNow) {
        infoText = getFormattedMessage(i18n.payments.ac.chargeNotificationNote, daysUntilExpired + 1);
    } else {
        infoText = i18n.payments.ac.chargeImmediatelyNote;
    }

    infoText += ` ${getFormattedMessage(i18n.payments.ac.afterChargeOneYearUsageAddedNote, getDateStr(expirationDate))}`

    if (daysUntilExpired < -365) {
        infoText += ` ${i18n.payments.ac.multiplePlanPaymentsNeededForCatchUpNote}`;
    }

    if (role === ROLES.END_USER && daysUntilExpired < -60) {
        costText = getFormattedMessage(i18n.payments.ac.totalCostWillBeNote, amount);
        infoText = getFormattedMessage(i18n.payments.ac.endUserRenewalFeeNote, getDateStr(expirationDate));
    }

    if (doNotRenew) {
        infoText += ` ${i18n.payments.setDoNotRenew}`;
    }

    return (
        <GenericItem title={costText}
                     testid={'acCostItem'}
                     details={infoText}/>
    );
};

export default AcCostItem;